<template>
	<div class="main">
		<!-- 头部 -->
    <Header :index="2"></Header>
		<!-- 面包屑导航 -->
		<div class="sec_top_position">
			<div class="curPosition">
				<img src="@/assets/img/fruit-transfer/icon14.png">
				您所在的位置：<a :href="homeHref">首页</a> &gt;
				<a href="#/platform/letter/list">互动交流</a> &gt;
				<a href="#">信件公示详情</a>
			</div>
		</div>
		<el-card class="detail">
			<div class="sq dTitle">微{{detailData.letterTypeCode==='consult'?'咨询':'建议'}}</div>
			<table class="dTable" align="center" width="100%" border="1px" borderColor="#ededed" cellspacing="0">
				<tr>
					<td class="t1">标题</td>
					<td class="t2" colspan="6">{{detailData.title}}</td>
				</tr>
				<tr>
					<td class="t1">来信时间</td>
					<td class="t2" colspan="3">{{detailData.submitTime | dateFormat("YYYY-MM-DD") }}</td>
					<td class="t1">来信人</td>
					<td class="t2" colspan="2">{{detailData.contactName}}</td>
				</tr>
				<tr>
					<td class="t1">来信内容</td>
					<td class="t2" colspan="6">{{detailData.content}}</td>
				</tr>
			</table>

			<div class="sl dTitle">受理回复</div>
			<table class="dTable" align="center" width="100%" border="1px" borderColor="#ededed" cellspacing="0">
				<tr>
					<td class="t1">答复时间</td>
					<td class="t2" colspan="6">{{detailData.replyTime | dateFormat("YYYY-MM-DD") }}</td>
				</tr>
				<tr>
					<td class="t1">答复部门</td>
					<td class="t2" colspan="6">{{detailData.acceptUnitName}}</td>
				</tr>
				<tr>
					<td class="t1">答复内容</td>
					<td class="t2" colspan="6">{{detailData.replyContent}}</td>
				</tr>
			</table>
		</el-card>
		<Footer></Footer>
	</div>
</template>

<script>
	import setRemPc from '@/api/setrem'
	import Header from '@/views/platform/components/header.vue'
	import Footer from '@/views/platform/components/footer.vue'
	import letterService from "@/api/platform-declare/letter";

	export default {
		components:{
			Header,
			Footer
		},
		data() {
			return {
				homeHref: process.env.VUE_APP_NAV_BASE_URL + 'ch00108/',
				detailId:'',
				detailData:{
					letterTypeCode:'',//信件类型
					title:'',//标题
					submitTime:'',//来信时间
					contactName:'',//来信人
					content:'',//来信内容

					replyTime:'',//答复时间
					acceptUnitName:'',//答复部门
					replyContent:'',//答复内容
				},

			};
		},
		mounted() {
			this.requestData(this.detailId)
		},
		created(){
			// 实例创建完成后被立即调用rem换算方法,解决内容闪现问题
			setRemPc();
			window.addEventListener('resize', setRemPc);//浏览器窗口大小改变时调用rem换算方法

			this.detailId = this.$route.query.letterId
		},
		methods: {
			requestData(id){
				letterService.queryOpenLetterDetail({letterId:id}).then(data => {
					console.log('======',data)
					this.detailData = data.data
				});
			}
		}
	};
</script>

<style lang="scss">
	@import url('~@/assets/css/breadnav.css');
	.main {
		font-size: 0.17rem;
		padding: 0;
		margin: -8px;
		background-color: #F5F5F5;
	}
	.detail{
		width: 15.7rem;
		/* height: 100%; */
		margin: 0.3rem auto;
		background-color: white;
	}
	.dTitle{
		/*width: 1.5rem;*/
		/*text-align: center;*/
		/*color:#ffffff;*/
		/*font-size: 0.19rem;*/
		/*height: 0.5rem;*/
		/*line-height: 0.5rem;*/
		/*background-color: #157ED6;*/

		height:0.2rem;
		box-sizing: border-box;
		padding-left: 0.2rem;
		border-left: 0.05rem solid #409EFF;
		font-size: 0.2rem;
		font-weight: bold;
		line-height: 0.2rem;
		margin: 0.2rem 0;
	}
	.sl{
		margin-top: 0.2rem;
	}
	.dTable{
		font-size: 0.18rem;
	}
	td{
		padding-top: 0.15rem;
		padding-bottom: 0.15rem;
	}
	.t1{
		width: 1rem;
		text-align: center;
		font-weight: bold;
	}
	.t2{
		padding-left: 0.1rem;
		text-indent:0.2rem;
	}
</style>
